import { createContext, useContext, useEffect, useState } from 'react';
import { makeProvider } from '../helpers/makeContexts';

const modalInit = {
  modals: [],
  dashboard: {},
};

function modalReducer(draft, { type, payload }) {
  switch (type) {
    case 'openModal': {
      if (draft.modals.indexOf(payload) === -1) {
        draft.modals.push(payload);
      }
      break;
    }
    case 'closeModal': {
      let index = draft.modals.indexOf(payload);
      if (index !== -1) {
        draft.modals.splice(index, 1);
      }
      break;
    }
    case 'setDashboard': {
      draft.dashboard = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [ModalContext, ModalDispatchContext] = [
  createContext(null),
  createContext(null),
];

export const ModalProvider = ({ init, children }) => {
  const initStore = init || modalInit;

  // Call makeProvider to create and return the provider component
  const ProviderComponent = makeProvider(
    ModalContext,
    ModalDispatchContext,
    modalReducer,
    initStore
  );

  // Return the generated provider component
  return <ProviderComponent>{children}</ProviderComponent>;
};

export function useModalDispatch() {
  return useContext(ModalDispatchContext);
}

export function useModalStore() {
  return useContext(ModalContext);
}

export function useModal(modalName) {
  const [open, setOpen] = useState(false);
  const { modals } = useContext(ModalContext);
  const dispatch = useModalDispatch();

  function setStatus(status) {
    if (
      status === true ||
      (typeof status === 'string' && status?.toLowerCase() === 'open')
    ) {
      dispatch({ type: 'openModal', payload: modalName });
    } else {
      dispatch({ type: 'closeModal', payload: modalName });
    }
  }

  useEffect(() => {
    let index = modals.indexOf(modalName);
    if (index === -1) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [modals]);

  return [open, setStatus];
}
